
export const isUrl = (value) => {
  const urlPattern = /^(https?:\/\/)?([\w.-]+)\.[\w.-]+(\/[^\s]*)?$/
  const localUrlPattern = /^(https?:\/\/)?localhost:\d+\/[^\s]*$/
  return urlPattern.test(value) || localUrlPattern.test(value)
}

export const getInvalidFeedback = (v) => {
  if (v && v.$dirty) {
    if (Object.hasOwn(v, 'required') && !v.required) {
      return 'Este campo es requerido'
    }
    if (Object.hasOwn(v, 'isUrl') && !v.isUrl) {
      return 'Debe ser una URL valida'
    }
  }
  return ''
}
